export default __webpack_public_path__ + "images/0x431516e478d73cfab034229c4d7a94a2cbf5787f.png";